<template>
  <div class="payment-select-list">
    <AmountDisplayer style="text-align: left"/>
    <Close/>
    <div class="payment-select-list__hint">{{ $t('paymentList.hint').toUpperCase() }}</div>
    <van-cell-group>
      <fragment
          v-if="balanceItem"
      >
        <van-cell
            :clickable="!balanceItem.disabled"
            @click="handleRecharge"
            v-if="rechargeShow"
        >
          <img v-if="balanceItem.round_mark" slot="icon" :src="balanceItem.round_mark" alt=""
               style="width: 24px;height: 24px">
          <SvgIcon v-else :icon-class="balanceItem.active?'wallet-active':'wallet'" slot="icon" width="24"
                   height="24"/>
          <div slot="title">{{
              balanceItem.display_name ? $t(balanceItem.display_name) : $t('paymentList.wallet')
            }}
          </div>
          <div slot="label">
            {{ $t('paymentList.balanceIsLow') }}
            ({{ getSymbol(get(info, 'orderInfo.hcurrency')) }}{{ fen2yuan(get(info, 'balance', 0))|currency }}).
          </div>
          <SvgIcon icon-class="right-arrow" slot="right-icon" width="24"
                   height="24"/>
        </van-cell>
        <van-cell
            v-else
            :clickable="!balanceItem.disabled"
            @click="handleChannelClick(balanceItem)"
        >
          <img v-if="balanceItem.round_mark" slot="icon" :src="balanceItem.round_mark" alt=""
               style="width: 24px;height: 24px">
          <SvgIcon v-else :icon-class="balanceItem.active?'wallet-active':'wallet'" slot="icon" width="24"
                   height="24"/>
          <div slot="title">{{
              balanceItem.display_name ? $t(balanceItem.display_name) : $t('paymentList.wallet')
            }}
          </div>
          <div slot="label">{{ $t('paymentList.balance') }}:
            {{ getSymbol(get(info, 'orderInfo.hcurrency')) }}{{ fen2yuan(get(info, 'balance', 0))|currency }}
          </div>
          <van-checkbox v-show="balanceItem.active" slot="right-icon" v-model="balanceItem.active"
                        :disabled="balanceItem.disabled">
            <SvgIcon :icon-class="balanceItem.active?`radio-on`:``" slot="icon" width="24" height="24"/>
          </van-checkbox>
        </van-cell>
      </fragment>
      <!--      <fragment v-if="creditCardItem">-->
      <!--        <van-cell-->

      <!--            :class="{'van-cell-active':creditCardItem.active,'disabled-blur':creditCardItem.disabled}"-->
      <!--            @click="handleChannelClick(creditCardItem)">-->
      <!--          <SvgIcon :icon-class="creditCardItem.active?'credit-card-active':'credit-card'" slot="icon"-->
      <!--                   width="24"-->
      <!--                   height="24"/>-->
      <!--          <div slot="title">{{ $t('paymentList.creditCard') }}</div>-->
      <!--        </van-cell>-->
      <!--      </fragment>-->
      <fragment v-for="(item,index) in otherPaymentMethods" :key="index">
        <van-cell :title="item.display_name ? $t(item.display_name) :item.pay_name"
                  :clickable="!item.disabled"
                  :class="{'van-cell-active':item.active,'disabled-blur':item.disabled}"
                  @click="handleChannelClick(item)">
          <img
              v-if="item.round_mark"
              :src="item.round_mark"
              alt=""
              style="width: 24px;height: 24px"
              slot="icon"
          >
          <SvgIcon v-else :icon-class="item.icon" slot="icon" width="24"
                   height="24"/>
          <div slot="label">
            {{ item.activity_text }}
          </div>
          <SvgIcon icon-class="right-arrow" slot="right-icon" width="24"
                   height="24"/>
        </van-cell>
      </fragment>
    </van-cell-group>
    <div style="width: 100%;display: flex;flex-direction: row-reverse">
      <van-button type="primary" class="payment-select-list__pay-button" v-show="balanceItem && balanceItem.active"
                  @click="goToPay">
        {{ $t('paymentList.pay') }}
      </van-button>
    </div>
  </div>
</template>

<script>
import {getCashierDetail, applyPay, getTappayConfig, getSKDConfig} from '@/api'
import { getSearchParams } from '@/utils'
import { get, find } from 'lodash-es'
import { fen2yuan, getSymbol } from '@/utils/currency'
import { paymentChannelHandler } from '@/utils/payment-channel-handler'
import qs from 'qs'
import { CREDIT_CARD_IDS } from '@/const/custom-payment-channel'
import { scriptLoader } from '@/utils/script-loader'
import { saRechargeClick, saPaySource, saPayMethods, saProceedPaymentType, saPayButtonClick } from '@/utils/sa-methods'
import { types, PAYMENT_ICONS_MAPPING, postMessage, getQS } from '@hll/cashier-kit'
import { PSLScreen } from '@/utils/screen'
import { setEvokePolicy } from '@/utils/localstorage-provider'

export default {
  name: 'PaymentSelectList',
  props: {
    payToken: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      paymentChannelId: '',
      info: {
        pay_cashier: []
      },
      paymentTypesMapping: PAYMENT_ICONS_MAPPING
    }
  },
  created () {
    PSLScreen()
    this.getListData()
  },
  methods: {
    fen2yuan,
    getListData () {
      const { payToken } = getSearchParams()
      getCashierDetail({ payToken }).then(res => {
        this.info = res
        this.$store.commit(types.SET_ORDER_INFO, res)
        // this.info.balance = 1000000
        this.info.pay_cashier = get(this, 'info.pay_cashier', [])
          .map(item => {
            const channelType = (item.pay_channel_id + '').slice(0, -2)
            const ret = {
              ...item,
              active: false,
              channelType,
              icon: this.paymentTypesMapping[channelType]?.icon
            }
            if (channelType === '3') {
              ret.disabled = get(this, 'info.balance', 0) < get(this, 'info.orderInfo.amount_fen', 0)
            }
            return ret
          })
        const channels = get(res, 'pay_cashier', [])
        for (const item of channels) {
          const channelType = (item.pay_channel_id + '').slice(0, -2)
          if (channelType === '15') {
            scriptLoader('https://js.tappaysdk.com/tpdirect/v5.5.0', () => {
              const TPDirect = window.TPDirect
              getTappayConfig({
                payToken: this.payToken,
                pay_channel_id: item.pay_channel_id
              }).then(({ app_id: appId, app_key: appKey, sandbox, card }) => {
                TPDirect.setupSDK(appId, appKey, sandbox ? 'production' : 'sandbox')
                if (card?.length) {
                  this.$store.commit(types.SET_STORED_CARDS, card)
                }
              })
            })
            break
          }
        }
        if (this.info.showCashier !== 1) {
          this.paymentChannelId = get(this, 'info.pay_cashier[0].pay_channel_id', '')
          this.goToPay()
        }
        const source = get(res, 'orderInfo.user_wallet_detail_type')
        saPaySource(source)
      })
    },
    goToPay () {
      if (this.paymentChannelId === '') {
        return this.$Message.warning('Please select payment method')
      }
      this.$emit(
        'paymentTypeChanged',
        String(this.paymentChannelId).slice(0, -2) === '3'
      )
      const { payToken } = getSearchParams()
      const params = {
        payToken,
        pay_channel_id: this.paymentChannelId,
        return_url_params: qs.stringify({ component: 'Result', type: 'unknown', payToken: this.payToken })
      }
      const payName = get(find(this.paymentChannelTransForm, { pay_channel_id: this.paymentChannelId }), 'pay_name', '')
      if (/^fake/.test(params.pay_channel_id)) {
        params.pay_channel_id = params.pay_channel_id.split('-')[1]
      }
      if (parseInt(this.paymentChannelId) === 901) {
        saPayMethods(payName)
        return this.$emit('goTo', { component: 'Adyen', payChannelID: this.paymentChannelId })
      }
      if (parseInt(this.paymentChannelId) === 1500) {
        saPayMethods(payName)
        return this.$emit('goTo', { component: 'Tappay', payChannelID: this.paymentChannelId })
      }
      if (parseInt(this.paymentChannelId) === 2104) {
        saPayMethods(payName)
        saProceedPaymentType(payName)
        return this.$emit('goTo', { component: 'Va', payChannelID: this.paymentChannelId })
      }
      if (parseInt(this.paymentChannelId) === 2106) {
        saPayMethods(payName)
        saProceedPaymentType(payName)
        return this.$emit('goTo', { component: 'Ovo', payChannelID: this.paymentChannelId })
      }
      applyPay(params).then(res => {
        const { evokeType, evokePolicy } = res
        setEvokePolicy(evokePolicy)

        switch (evokeType) {
          case 1:
            this.$emit('goTo', { component: 'Result', type: 'unknown' })

            break
          case 2:
            paymentChannelHandler({ res, ctx: this })
            break
          default :
            break
        }
      })
      saPayMethods(payName)
      saProceedPaymentType(payName)
      saPayButtonClick(payName)
    },
    handleChannelClick (itemClick) {
      if (itemClick.disabled) {
        return
      }
      // 排它并选中
      get(this, 'info.pay_cashier', []).forEach(item => {
        if (itemClick.pay_channel_id === this.balanceItem?.pay_channel_id && item.pay_channel_id === itemClick.pay_channel_id) {
          item.active = !item.active
        } else {
          item.active = false
        }
      })
      this.paymentChannelId = itemClick.pay_channel_id
      if (this.balanceItem?.pay_channel_id !== itemClick.pay_channel_id) {
        this.goToPay()
      }
      const payName = get(find(this.paymentChannelTransForm, { pay_channel_id: itemClick.pay_channel_id }), 'pay_name', '')
      saPayMethods(payName)
    },
    getSymbol,
    get,
    handleRecharge () {
      this.$Spin.show()
      saRechargeClick()
      postMessage({ action: 'recharge' })
      setTimeout(() => {
        this.$Spin.hide()
      }, 5000)
    }
  },
  computed: {
    otherPaymentMethods () {
      return this.paymentChannelTransForm
        .filter(item => {
          return item.pay_channel_id !== this.balanceItem?.pay_channel_id
        })
    },
    paymentAmount () {
      return get(this, 'info.orderInfo.amount_fen')
    },
    balanceItem () {
      // 检查是否可以余额支付
      return find(this.paymentChannelTransForm, { channelType: '3' })
    },
    paymentChannelTransForm () {
      return get(this, 'info.pay_cashier', []).map(item => {
        const channelType = (item.pay_channel_id + '').slice(0, -2)
        return {
          ...item,
          channelType,
          icon: this.paymentTypesMapping[channelType]?.icon
        }
      }).sort((a, b) => {
        return a.rank - b.rank
      })
    },
    creditCardItem () {
      for (const ID of CREDIT_CARD_IDS) {
        const eureka = find(this.paymentChannelTransForm, { pay_channel_id: ID })
        if (eureka) {
          return eureka
        }
      }
      return null
    },
    balance () {
      return get(this.info, 'balance', 0)
    },
    rechargeShow () {
      return this.balance === 0 || this.balance < this.paymentAmount
    }
  },
  watch: {
    'info.balance' () {
      if (this.balanceItem && !this.rechargeShow) {
        get(this, 'info.pay_cashier', []).forEach(item => {
          item.active = false
          if (this.balanceItem.pay_channel_id === item.pay_channel_id) {
            item.active = true
            this.paymentChannelId = item.pay_channel_id
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.payment-select-list {
  padding: 48px 40px;

  [class*='van-hairline']::after {
    border: none;
  }

  &__pay-button {
    width: 104px;
    height: 36px;
    margin-top: 24px;
  }

  &__balance-dropdown {
    padding-top: 12px;

    &__text {
      color: #888;
      font-size: 12px;
    }

    &__button {
      margin-top: 8px;
      width: 100px;
      height: 32px;
    }
  }

  &__other-payments {
    padding-top: 12px;

    &__text {
      color: #303030;
      font-size: 14px;
    }

    &__button {
      margin-top: 8px;
      width: 100px;
      height: 32px;
    }
  }

  &__title {
    display: flex;
    justify-content: space-between;
    color: #737373;
    font-size: 12px;
    font-weight: bold;
  }

  &__currency {
    color: #737373;
    font-size: 32px;
  }

  &__hint {
    color: #737373;
    font-size: 12px;
    margin-top: 20px;
    margin-bottom: 24px;
    font-weight: bold;
  }

  ::v-deep .van-cell-group {
    background: transparent;
  }

  ::v-deep .van-cell {
    color: #1A1A1A;
    font-weight: bold;
    min-height: 56px;
    display: flex;
    align-items: center;
    position: relative;

    &:not(:last-of-type) {
      &::after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        left: 50px;
        bottom: 0;
        height: 1px;
        background-color: #c8c7cc;
        transform: scaleY(0.5);
      }
    }

    &__title {
      margin-left: 10px;
      color: #303030;
      font-size: 14px;
      width: 100%;
    }

    &__label {
      color: #888;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }

    &-active {
      color: #F16622;
      border-color: #F16622;
    }

    &::after {
      border: 0;
    }
  }

  &__process {
    width: 100%;
    font-weight: bold;
  }

  .disabled-blur {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &__recharge {
    color: #F16622;
    cursor: pointer;
  }
}
</style>
